module.exports = __webpack_public_path__ + "img/webpack.07b563f1.svg";